import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {withdraw, withdraws, withdrawApprove, withdrawDisapprove,withdrawAutoEnable,withdrawAutoDisable,transExport,withdrawableStats,transSubjestStats,withdrawableTotal} = api


/**
 * 查找提现记录
 */
export async function findWithdraw(params) {
    return request({url: withdraw, method: 'get', data: params,})
}


/**
 * 查找提现记录列表
 */
export async function findWithdraws(params) {
    return request({url: withdraws, method: 'get', data: params,})
}/**
 * 流水导出
 */
export async function exportTrans(params) {
    return request({url: transExport, method: 'get', data: params,})
}

/**
 *  创建提现申请
 */
export async function createWithdraw(params) {
    return request({url: withdraws, method: 'post', data: params,})
}

/**
 * 审核
 */
export async function approveWithdraw(params) {
    return request({url: withdrawApprove, method: 'post', data: params,})
}

export async function disapproveWithdraw(params) {
    return request({url: withdrawDisapprove, method: 'post', data: params,})
}

/**
 * 自动提现开关
 */
export async function enableAutoWithdraw(params) {
    return request({url: withdrawAutoEnable, method: 'post', data: params,})
}

export async function disableAutoWithdraw(params) {
    return request({url: withdrawAutoDisable, method: 'post', data: params,})
}
//可提现统计
export async function findWithdrawableStats(params) {
    return request({url: withdrawableStats, method: 'get', data: params,})
}
//收支统计
export async function findTransSubjestStats(params) {
    return request({url: transSubjestStats, method: 'get', data: params,})
}
//可提现总额
export async function findWithdrawableTotal(params) {
    return request({url: withdrawableTotal, method: 'get', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/withdram.js